import { infiniteQueryOptions, keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import { getOfficerPerformance, PAGE_SIZE, type ReportFilters } from '../api/reportsApi'
import { nextReportOffset } from '../lib/reports-paging'
import { reportsScopeParams } from '../lib/reports-scope'

/**
 * Officer × mandal performance for the Officers tab, paginated via offset. Keyed by the resolved report
 * params so the cache reacts to period/entity/mandal changes AND restarts at offset 0 on any change;
 * keepPreviousData stops the table flashing empty on a filter switch. Reports change slowly → 2m staleTime.
 */
export const officerPerformanceQueryOptions = (filters: ReportFilters) =>
  infiniteQueryOptions({
    queryKey: ['gis', 'reports', 'officer-performance', reportsScopeParams(filters.scope, { mandal: filters.mandal })] as const,
    queryFn: ({ pageParam }) => getOfficerPerformance(filters, pageParam),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      nextReportOffset(allPages.reduce((sum, p) => sum + p.rows.length, 0), lastPage.totalCount, lastPage.rows.length, PAGE_SIZE),
    staleTime: 1000 * 60 * 2,
    placeholderData: keepPreviousData,
  })

export function useOfficerPerformance(filters: ReportFilters) {
  return useInfiniteQuery(officerPerformanceQueryOptions(filters))
}
